import { parsePhoneNumberFromString } from 'libphonenumber-js';

const NON_DIGIT_CHARS = /\D+/g;

export function normalizePhoneNumberToE164(value: string): string | null {
    const trimmed = value.trim();
    const parsed = parsePhoneNumberFromString(trimmed, 'US');
    if (parsed?.isValid()) {
        return parsed.number;
    }

    const digits = trimmed.replace(NON_DIGIT_CHARS, '');
    if (digits.length === 10) {
        return `+1${digits}`;
    }
    // E.164 country codes are 1-9, so a digits-only string starting with 0
    // can never be a valid E.164 number even with a leading "+".
    if (digits.length >= 11 && digits.length <= 15 && digits[0] !== '0') {
        return `+${digits}`;
    }
    return null;
}
